import React, { useState, useEffect } from 'react';

export function Pagination({ p, l, c, sp, s, e }) {
  const [page, sPage] = useState(p)
  const [limit] = useState(l)
  const [count, setCount] = useState(c)
  const [min] = useState(1)
  const [max, setMax] = useState(Math.ceil(c / limit))
  const [iStart, setStart] = useState(s)
  const [iEnd, setEnd] = useState(e)
  const [pageLists, setPageLists] = useState([])
  const [pageNumberList, setPageNumberList] = useState([])

  const [groupCount] = useState(5)
  const [groupCountMax] = useState(2)
  // const[startPage, setStartPage] = useState(1)

  const [preClass, setPreClass] = useState("")
  const [nextClass, setNextClass] = useState("")
  //console.log("Pagination")

  useEffect(() => {
    //console.log(p)
    if (p !== page) {
      sPage(p)
    }
  }, [p, page])

  useEffect(() => {
    if (c !== count) {
      setCount(c)
    }
    // console.log(c)
    // console.log(limit)
    // console.log(Math.ceil(c / limit))
    var max = Math.ceil(c / limit)
    setMax(max)
    var pl = []
    for (let i = min; i <= max; i++) {
      pl.push(i)
    }
    setPageLists(pl)
  }, [c, count])

  useEffect(() => {
    // console.log(pageLists)
    setPageNumber()
  }, [pageLists])

  useEffect(() => {
    if (s !== iStart) {
      setStart(s)
    }
  }, [s])
  useEffect(() => {
    if (e !== iEnd) {
      setEnd(e)
    }
  }, [e])

  useEffect(() => {
    if (page === min) {
      setPreClass("paginate_button previous disabled")
    } else {
      setPreClass("paginate_button previous")
    }
    if (page === max) {
      setNextClass("paginate_button next disabled")
    } else {
      setNextClass("paginate_button next")
    }
    setPageNumber()
  }, [page, max])

  function setPage(pg) {
    console.log("setPage")
    if (pg <= max && pg >= min)
      sp(pg);
  }

  function setPageNumber() {
    // console.log('setPageNumber')
    var startPage = 1
    var pages = []
    if (max <= 10) {
      pageLists.map((pageNumber) => {
        pages.push(<PageNumber key={"pn" + pageNumber} page={page} number={pageNumber} setPage={setPage} />)
      }
      )
    } else {
      let pageLength = 0;
      pages.push(<PageNumber key={"pn" + 1} page={page} number={1} setPage={setPage} />)

      if (page >= groupCount) {
        pages.push(<PageNumber key={"pn" + '···0'} page={page} number={'···'}  />)
        startPage = page - 2
      }
      if (groupCount + startPage > max) {
          pageLength = max
      } else {
          pageLength = groupCount + startPage;
      }
      for (let i = startPage; i < pageLength; i++) {
          if (i <= max - 1 && i > 1) {
              pages.push(<PageNumber key={"pn" + i} page={page} number={i} setPage={setPage} />)
          }
      }


      if (max - startPage >= groupCount + 1) {
        pages.push(<PageNumber key={"pn" + '···1'} page={page} number={'···'}  />)


      let pageMaxLength = max
      if(pageMaxLength - groupCountMax > pageLength){
        pageMaxLength = pageMaxLength - groupCountMax
      }
      for(let i=pageMaxLength; i < max ; i ++){
        pages.push(<PageNumber key={"pn" + i} page={page} number={i} setPage={setPage} />)
      }
    }
      pages.push(<PageNumber key={"pn" + max} page={page} number={max} setPage={setPage} />)
    }
    setPageNumberList(pages)
  }

  if (count === 0) {
    return (<></>)
  } else {
    return (
      <div className="row">
        <div className="col-sm-5">
          <div className="dataTables_info" id="editable_info" role="status" aria-live="polite">
            顯示 {iStart} to {iEnd} 共 {count} 筆
              </div>
        </div>
        <div className="col-sm-7">
          <div className="dataTables_paginate paging_simple_numbers" id="editable_paginate">
            <ul className="pagination"><li className={preClass} id="editable_previous">
              <a href="#A" aria-controls="editable" onClick={e => setPage(page - 1)} >上一頁</a>
            </li>
              {
                pageNumberList.map((pageNumber) =>
                  pageNumber
                )
              }
              <li className={nextClass} id="editable_next">
                <a href="#A" aria-controls="editable" onClick={e => setPage(page + 1)}>下一頁</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }

}

function PageNumber({ page, number, setPage }) {
  var cn = ""
  if (page === number) {
    cn = "paginate_button active"
  }
  function sp(){
    if(setPage !== undefined){
      setPage(number)
    }
  }
  return (
    <li className={cn}><a href="#A" onClick={() => sp(number)}>{number}</a></li>
  )
}